

import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import 'react-datepicker/dist/react-datepicker.css';
import styles from '../../assets/scss/Invoice/AddInvoice.module.scss';
import { FaUpload, FaTrashAlt, FaEdit } from 'react-icons/fa';
import Pagination from '../../Components/Common/Pagination';
import PopupWrapper from '../../Components/Common/PopupWrapper';
import AddItemPopup from './AddItemPopup';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import DeleteConfirmModal from '../../Components/Common/DeleteConfirmModal';
import {
    useGetLogisticsQuery,
    useGetMyInvoiceByIdQuery,
    useGetMyInvoicesselfQuery,
    useGetMyVendorsQuery,
    useGetUserByIdQuery
} from '../../slices/admin/admin';
import { BaseURL } from '../../lib/api';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getUserInfo } from '../../utils/user.util';
import ImagePriview from '../../Components/Common/ImagePriview';
import Select from "react-select";

const UpdateMyInvoice = () => {
    const [items, setItems] = useState([]);
    const [effectiveDate, setEffectiveDate] = useState(null);
    const [isAddItemOpen, setIsAddItemOpen] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [editIndex, setEditIndex] = useState(null);
    const [saleCommission, setSaleCommission] = useState('');


    const [assignedTo, setAssignedTo] = useState('');
    const [paymentType, setPaymentType] = useState('');
    const [logisticsId, setLogisticsId] = useState('');
    const [logisticsAmount, setLogisticsAmount] = useState('');
    const [logisticsPaymentBy, setLogisticsPaymentBy] = useState('');
    const [userData, setUserData] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);

    const navigate = useNavigate();
    const location = useLocation();
    const viewOnly = location.state?.viewOnly || false;
    const invoiceId = location.state?.invoiceId || null;


    const [searchParams] = useSearchParams();

    const goBackWithTab = () => {
        const activeTab = searchParams.get("tab") || "myInvoice";
        navigate(`/dashboard/InvoiceTable?tab=${activeTab}`);
    };

    const { data: invoiceData, refetch: refetchdata } = useGetMyInvoiceByIdQuery(invoiceId, { skip: !invoiceId });

    // console.log('Invoice Data:', invoiceData);

    const { data: sortbystoredata } = useGetMyVendorsQuery();
    const stores = sortbystoredata?.stores || [];
    const { data: logisticsData } = useGetLogisticsQuery();
    const logisticsList = logisticsData?.logistics || [];


    const { refetch } = useGetMyInvoicesselfQuery({
        offset: 1,
        limit: 10,
        status: '',
        invoiceStore: '',
        period: '',
        search: '',
    });

    // ✅ Handles both absolute and relative image URLs safely
    const resolveImageUrl = (path) => {
        if (!path) return null;
        return path.startsWith('http')
            ? path
            : `${BaseURL.replace(/\/$/, '')}/${path.replace(/^\/+/, '')}`;
    };



    const user = getUserInfo();
    const userId = user?._id;
    const { data: profileData } = useGetUserByIdQuery(userId, { skip: !userId });


    useEffect(() => {
        if (invoiceData?.myInvoices?.length) {
            const invoice = invoiceData.myInvoices[0];

            setAssignedTo(invoice.invoiceStore?._id || '');
            setPaymentType(invoice.paymentType || '');
            setEffectiveDate(invoice.paymentDate || '');
            setLogisticsId(invoice.logisticsId || '');
            setLogisticsAmount(invoice.amount || '');
            setLogisticsPaymentBy(invoice.logisticsPaymentBy || '');
            setSaleCommission(invoice.saleCommission || '');

            // const formattedItems = (invoice.items || []).map((item) => ({
            //     itemId: item._id, // <-- Inject _id from backend
            //     invoiceId: item.invoiceId,
            //     name: item.productName,
            //     quantity: item.productQuantity,
            //     quality: item.productQuality,
            //     bag: item.productBag,
            //     description: item.description || '',
            //     imagePreview: `${BaseURL}/${item.profile}`,
            //     image: `${BaseURL}/${item.profile}`,
            // }));

            // const formattedItems = (invoice.items || []).map((item) => ({
            //     itemId: item._id,
            //     invoiceId: item.invoiceId,
            //     name: item.productName,
            //     quantity: item.productQuantity,
            //     productCount: item.productCount || '', // ← ADD THIS
            //     quality: item.productQuality,
            //     bag: item.productBag,
            //     description: item.description || '',
            //     imagePreview: `${BaseURL}/${item.profile}`,
            //     image: `${BaseURL}/${item.profile}`,
            // }));

            const formattedItems = (invoice.items || []).map((item) => {
                const imageUrl = resolveImageUrl(item.profile);
                return {
                    itemId: item._id,
                    invoiceId: item.invoiceId,
                    name: item.productName,
                    quantity: item.productQuantity,
                    productCount: item.productCount || '',
                    quality: item.productQuality,
                    bag: item.productBag,
                    description: item.description || '',
                    imagePreview: imageUrl,
                    image: imageUrl,
                };
            });



            setItems(formattedItems);
        }
    }, [invoiceData]);

    useEffect(() => {
        if (invoiceData?.myInvoices?.length) {
            const invoice = invoiceData.myInvoices[0];
            const store = invoice.invoiceStore;

            setUserData({
                firstName: '', // not available in this API response
                lastName: '',
                phone: '',      // not available directly
                address: store
                    ? `${store.address1 || ''}, ${store.address2 || ''}, ${store.city || ''}, ${store.state || ''} - ${store.pincode || ''}`
                    : 'N/A',
            });
        } else if (profileData?.result?.[0]) {
            const user = profileData.result[0];
            const store = user?.store;

            setUserData({
                firstName: user?.firstName || '',
                lastName: user?.lastName || '',
                phone: user?.phone || '',
                address: store
                    ? `${store.address1 || ''}, ${store.address2 || ''}, ${store.city || ''}, ${store.state || ''} - ${store.pincode || ''}`
                    : 'N/A',
            });
        }
    }, [invoiceData, profileData]);


    // useEffect(() => {
    //     const storedItems = localStorage.getItem('invoiceItems');
    //     if (storedItems) {
    //         try {
    //             const parsed = JSON.parse(storedItems);
    //             const sanitized = parsed.map(item => ({ ...item, image: null }));
    //             setItems(sanitized);
    //         } catch (err) {
    //             console.error('Error parsing stored items:', err);
    //         }
    //     }
    // }, []);

    // useEffect(() => {
    //     if (items.length > 0) {
    //         localStorage.setItem('invoiceItems', JSON.stringify(items));
    //     }
    // }, [items]);

    const totalPages = Math.ceil(items.length / limit);
    const paginatedItems = items.slice((currentPage - 1) * limit, currentPage * limit);

    const confirmDelete = () => {
        const updated = items.filter((_, idx) => idx !== deleteId);
        setItems(updated);
        //    localStorage.setItem('invoiceItems', JSON.stringify(updated));
        setModalOpen(false);
    };

    const handleEdit = (item, index) => {
        setEditIndex((currentPage - 1) * limit + index);
        setIsAddItemOpen(true);
    };

    const handleCancel = () => {
        //  localStorage.removeItem('invoiceItems');
        navigate(-1);
    };





    const handleSave = async () => {
        // if (!assignedTo || !paymentType || !effectiveDate || !logisticsId || !logisticsAmount || !logisticsPaymentBy || items.length === 0) {
        //     toast.error('Please fill all required fields and add at least one item.');
        //     return;
        // }

        if (!assignedTo || !logisticsId || !logisticsAmount || !logisticsPaymentBy || !saleCommission || items.length === 0) {
            toast.error('Please fill all required fields and add at least one item.');
            return;
        }


        try {
            const formData = new FormData();
            formData.append('invoiceStore', assignedTo);
            // formData.append('paymentType', paymentType);
            // formData.append('paymentDate', effectiveDate);
            formData.append('logisticsId', logisticsId);
            formData.append('amount', logisticsAmount);
            formData.append('logisticsPaymentBy', logisticsPaymentBy);
            formData.append('saleCommission', saleCommission);


            // const products = [];
            // for (let i = 0; i < items.length; i++) {
            //     const item = items[i];
            //     const fieldName = `product${i + 1}profile`;

            //     if (item.image && item.image instanceof File) {
            //         formData.append(fieldName, item.image);
            //     } else {
            //         formData.append(fieldName, null);
            //     }

            //     products.push({
            //         _id: item.itemId,
            //         productName: item.name,
            //         productQuantity: item.quantity,
            //         productBag: item.bag,
            //         productQuality: item.quality,
            //         description: item.description || '',
            //         productCount: Number(item.productCount || 0),
            //         fieldName,
            //     });

            // }

            const products = [];

            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                const fieldName = `product${i + 1}profile`;

                if (item.image && item.image instanceof File) {
                    formData.append(fieldName, item.image);
                } else {
                    formData.append(fieldName, null);
                }

                const productData = {
                    _id: item._id || item.itemId,
                    productName: item.name,
                    productQuantity: Number(item.quantity || 0),
                    productQuality: item.quality,
                    productBag: item.bag,
                    productCount: Number(item.productCount || 0),
                    description: item.description || '',
                    fieldName
                };

                products.push(productData);
            }




            formData.append('products', JSON.stringify(products));

            let token = localStorage.getItem('token');
            if (token?.startsWith('"') && token?.endsWith('"')) {
                token = token.slice(1, -1);
            }

            if (!token) {
                toast.error('Token is missing!');
                return;
            }

            await axios.put(`${BaseURL}/invoice/update/${invoiceId}`, formData, {
                headers: { authorization: token },
            });

            toast.success('Invoice updated successfully!');
            refetch();
            refetchdata();
            //localStorage.removeItem('invoiceItems');
            // navigate(-1);
            // navigate(user?.type === 'farmer' ?  '/dashboard/InvoiceTable' :  '/dashboard/Invoicetable', {
            //     state: { shouldRefetch: true },
            // });
            // localStorage.setItem('myInvoiceNeedsRefetch', 'true');
            // navigate(user?.type === 'farmer' ? '/dashboard/InvoiceTable' : '/dashboard/Invoicetable', {
            //     state: {
            //         shouldRefetch: true,
            //         activeTab: 'myInvoice',
            //     },
            // });
            goBackWithTab();

        } catch (err) {
            console.error('Error updating invoice:', err);
            toast.error('Failed to update invoice');
        }
    };


    return (
        <div className={styles.invoiceContainer}>
            <div className={styles.header}>
                <h2 className={styles.tittle}>Update Invoice</h2>
                <span className={styles.closeIcon}
                    //onClick={handleCancel}
                    onClick={goBackWithTab}
                >×</span>
            </div>

            <div className={styles.AddInvoicehead}>
                <div className={styles.formSection}>
                    <div className={styles.assignRow}>

                        <div>
                            <div className={styles.inputGroupss}>
                                <label className={styles.inputLabel}>Invoice Placed To</label>
                                <Select
                                    className={styles.customSelect}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            border: "1px solid #6D6D6D",
                                            borderRadius: "6px",
                                            fontSize: "16px",
                                            minHeight: "50px",
                                            boxShadow: "none",
                                            color: "black",
                                            fontWeight: "600",
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            color: "#6D6D6D",
                                            fontSize: "16px",
                                            fontWeight: "600",
                                        }),
                                    }}
                                    value={
                                        stores.find((store) => store._id === assignedTo)
                                            ? {
                                                value: assignedTo,
                                                label: stores.find((store) => store._id === assignedTo)?.storeName,
                                            }
                                            : null
                                    }
                                    onChange={(selectedOption) =>
                                        setAssignedTo(selectedOption ? selectedOption.value : "")
                                    }
                                    options={stores.map((store) => ({
                                        value: store._id,
                                        label: store.storeName,
                                    }))}
                                    placeholder="Select Store"
                                    isSearchable
                                />
                            </div>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Sale Commission</label>
                                <select
                                    className={styles.inputs}
                                    value={saleCommission}
                                    onChange={(e) => setSaleCommission(e.target.value)}
                                >
                                    <option value="">Select Commission Type</option>
                                    <option value="percentage">Percentage (%)</option>
                                    <option value="price">Price ($)</option>
                                </select>
                            </div>

                        </div>



                        {userData && (
                            <div className={styles.ownerCard}>
                                <p><strong>Item Owner :</strong> {userData.firstName} {userData.lastName}</p>
                                <p><strong>Address :</strong> {userData.address}</p>
                                <p><strong>Phone No :</strong> {userData.phone}</p>
                            </div>
                        )}
                    </div>

                    {/* <div className={styles.box}>
                        <h4>Commission Details</h4>
                        <div className={styles.grid}>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Sale Commission</label>
                                <select
                                    className={styles.inputs}
                                    value={saleCommission}
                                    onChange={(e) => setSaleCommission(e.target.value)}
                                >
                                    <option value="">Select Commission Type</option>
                                    <option value="percentage">Percentage (%)</option>
                                    <option value="price">Price ($)</option>
                                </select>
                            </div>
                          


                        </div>
                    </div> */}

                    {/* <div className={styles.box}>
                        <h4>Transport Details</h4>
                        <div className={styles.grid}>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Transport Name</label>
                                <select className={styles.inputs} value={logisticsId} onChange={(e) => setLogisticsId(e.target.value)}>
                                    <option value="">Select Transport</option>
                                    {logisticsList.map(log => (
                                        <option key={log._id} value={log._id}>{log.store?.storeName}</option>
                                    ))}
                                </select>
                            </div>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Transport Amount Accepted</label>
                                <input
                                    type='number'
                                    className={styles.input}
                                    placeholder='Transport Amount'
                                    value={logisticsAmount}
                                    onChange={(e) => setLogisticsAmount(e.target.value)}
                                />
                            </div>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Transport Amount Paid ID</label>
                                <select className={styles.inputs} value={logisticsPaymentBy} onChange={(e) => setLogisticsPaymentBy(e.target.value)}>
                                    <option value="">Select Type</option>
                                    <option value="farmer">Farmer</option>
                                    <option value="store">Store</option>
                                </select>
                            </div>
                        </div>
                    </div> */}
                </div>

                <div className={styles.tableHeader}>
                    <button className={styles.addBtn} onClick={() => setIsAddItemOpen(true)}>+ Add Item</button>
                </div>

                <div className={styles.tableWrapper}>
                    <table>
                        <thead>
                            <tr>
                                <th>Item Seq</th>
                                <th>Item Name</th>
                                <th>Item Descriptions</th>
                                <th>Item Quantity</th>
                                <th>Item Count</th>
                                <th>Item Quality</th>
                                <th>Item Scales</th>
                                <th>Item Images</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* {paginatedItems.length > 0 ? paginatedItems.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.name}</td>
                                    <td>{item.description}</td>
                                    <td>{item.quantity}</td>
                                    <td>
                                        {item.bag !== 'kilogram' ? item.productCount || '-' : '-'}
                                    </td>
                                    <td>{item.quality}</td>
                                    <td>{item.bag}</td>

                                    <>
                                        <td>
                                            {item.imagePreview && (
                                               
                                                <img
                                                    src={item.imagePreview}
                                                    width="40"
                                                    height="40"
                                                    alt="item"
                                                    style={{ cursor: 'pointer', objectFit: 'cover' }}
                                                    // onError={(e) => (e.target.style.display = 'none')}
                                                    onClick={() => setSelectedImage(item.imagePreview)}
                                                />


                                            )}
                                        </td>

                                        {selectedImage && (
                                            <ImagePriview
                                                isOpen={true}
                                                imageUrl={selectedImage}
                                                onClose={() => setSelectedImage(null)}
                                            />
                                        )}
                                    </>
                                    <td>
                                        <div className={styles.actionsss}>
                                            <FaEdit className={styles.icon} onClick={() => handleEdit(item, index)} />
                                            <FaTrashAlt className={styles.icon} onClick={() => {
                                                setDeleteId((currentPage - 1) * limit + index);
                                                setModalOpen(true);
                                            }} />
                                        </div>
                                    </td>
                                </tr>
                            )) : (
                                <tr><td colSpan="8" className={styles.noData}>No data found</td></tr>
                            )} */}
                            {paginatedItems.length > 0 ? paginatedItems.map((item, index) => {
                                const globalIndex = (currentPage - 1) * limit + index;
                                return (
                                    <tr key={globalIndex}>
                                        <td>{globalIndex + 1}</td>
                                        <td>{item.name}</td>
                                        <td>{item.description}</td>
                                        <td>{item.quantity}</td>
                                        <td>
                                            {item.bag !== 'kilogram' ? item.productCount || '-' : '-'}
                                        </td>
                                        <td>{item.quality}</td>
                                        <td>{item.bag}</td>
                                        <td>
                                            {item.imagePreview ? (
                                                <img
                                                    src={item.imagePreview}
                                                    width="40"
                                                    height="40"
                                                    alt="item"
                                                    style={{ cursor: 'pointer', objectFit: 'cover', borderRadius: '4px' }}
                                                    onClick={() => setSelectedImage(item.imagePreview)}
                                                />
                                            ) : (
                                                <span>-</span>
                                            )}
                                        </td>
                                        <td>
                                            <div className={styles.actionsss}>
                                                <FaEdit
                                                    className={styles.icon}
                                                    onClick={() => handleEdit(item, index)}
                                                />
                                                <FaTrashAlt
                                                    className={styles.icon}
                                                    onClick={() => {
                                                        setDeleteId(globalIndex);
                                                        setModalOpen(true);
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                );
                            }) : (
                                <tr><td colSpan="9" className={styles.noData}>No data found</td></tr>
                            )}
                        </tbody>
                    </table>

                    <div className={styles.paginationWrapper}>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(page) => setCurrentPage(page)}
                        />
                        <select
                            className={styles.inputsbtn}
                            value={limit}
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={10}>10 rows</option>
                            <option value={25}>25 rows</option>
                            <option value={50}>50 rows</option>
                        </select>
                    </div>
                </div>

              
                {/* <div className={styles.box}>
                    <h4>Transport Details</h4>
                    <div className={styles.grid}>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Transport Name</label>
                            <select className={styles.inputs} value={logisticsId} onChange={(e) => setLogisticsId(e.target.value)}>
                                <option value="">Select Transport</option>
                                {logisticsList.map(log => (
                                    <option key={log._id} value={log._id}>{log.store?.storeName}</option>
                                ))}
                            </select>
                        </div>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Transport Amount Accepted</label>
                            <input
                                type='number'
                                className={styles.input}
                                placeholder='Transport Amount'
                                value={logisticsAmount}
                                onChange={(e) => setLogisticsAmount(e.target.value)}
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Transport Amount Paid ID</label>
                            <select className={styles.inputs} value={logisticsPaymentBy} onChange={(e) => setLogisticsPaymentBy(e.target.value)}>
                                <option value="">Select Type</option>
                                <option value="farmer">Farmer</option>
                                <option value="store">Store</option>
                            </select>
                        </div>
                    </div>
                </div> */}
                <div className={styles.summaryCard}>
                     <div className={styles.grid}>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Transport Name</label>
                            <select className={styles.inputs} value={logisticsId} onChange={(e) => setLogisticsId(e.target.value)}>
                                <option value="">Select Transport</option>
                                {logisticsList.map(log => (
                                    <option key={log._id} value={log._id}>{log.store?.storeName}</option>
                                ))}
                            </select>
                        </div>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Transport Amount Accepted</label>
                            <input
                                type='number'
                                className={styles.input}
                                placeholder='Transport Amount'
                                value={logisticsAmount}
                                onChange={(e) => setLogisticsAmount(e.target.value)}
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Transport Amount Paid ID</label>
                            <select className={styles.inputs} value={logisticsPaymentBy} onChange={(e) => setLogisticsPaymentBy(e.target.value)}>
                                <option value="">Select Type</option>
                                <option value="farmer">Farmer</option>
                                <option value="store">Store</option>
                            </select>
                        </div>
                    </div>
                    <div className={styles.totalBox}>
                        <h4 className={styles.totalhead}>Total Item Count</h4>
                        <div className={styles.row}>
                            <p><strong>Total Quantity:</strong> {items.reduce((acc, item) => acc + Number(item.quantity || 0), 0)}</p>
                            <p><strong>Total Item Scales:</strong> {items.length.toString().padStart(2, '0')}</p>
                            <p><strong>Total Item Count : </strong>{items.length}</p>
                            <p><strong>Total  : </strong>{items.length}</p>
                        </div>
                    </div>
                    {/* <div className={styles.countBox}>
                        <div className={styles.countflex}>
                            <p><strong>Total Item Count</strong></p>
                            <h2>{items.length}</h2>
                        </div>
                        <hr />
                        <div className={styles.countflex}>
                            <p>Total</p>
                            <h2>{items.length}</h2>
                        </div>
                    </div> */}
                </div>
                  <div className={styles.footerButtons}>
                    <button className={styles.cancel}
                        //onClick={handleCancel}
                        onClick={goBackWithTab}
                    >Cancel</button>
                    <button className={styles.save} onClick={handleSave}>Update My Invoice</button>
                </div>
            </div>

            {isAddItemOpen && (
                <PopupWrapper onClose={() => {
                    setIsAddItemOpen(false);
                    setEditIndex(null);
                }}>
                    <AddItemPopup
                        onClose={() => {
                            setIsAddItemOpen(false);
                            setEditIndex(null);
                        }}
                        itemToEdit={items[editIndex]}
                        onSave={(newItem) => {
                            if (editIndex !== null) {
                                const updated = [...items];
                                updated[editIndex] = newItem;
                                setItems(updated);
                            } else {
                                setItems(prev => [...prev, newItem]);
                            }
                            setIsAddItemOpen(false);
                            setEditIndex(null);
                        }}
                    />
                </PopupWrapper>
            )}


            {selectedImage && (
                <ImagePriview
                    isOpen={true}
                    imageUrl={selectedImage}
                    onClose={() => setSelectedImage(null)}
                />
            )}

            <DeleteConfirmModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                onConfirm={confirmDelete}
            />
        </div>
    );
};

export default UpdateMyInvoice;






